
<template>
  <div class="ui-title-text" :style="style">
      <slot></slot>                
  </div>
</template>

<script>
export default {

    name: 'UITitle',

    props: {
      align: {
        type: String,
        default: 'left'
      }
    },

    computed: {
      style () {
        return {
          '--align': this.align
        }
      }
    },
}
</script>

<style>
  .ui-title-text{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 100.7%;
    
    color: #000000;
  }
  @media (max-width: 1650px) {
    .ui-title-text{
      font-size: 32px;
    }
  }
  @media (max-width: 1350px) {
    .ui-title-text{
      font-size: 27px;
    }
  }
  @media (max-width: 850px) {
    .ui-title-text{
      font-size: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// UITitle.vue?40f22ea5